import React, { useState, useEffect } from "react";
import {
  XYPlot,
  LineSeries,
  VerticalGridLines,
  HorizontalGridLines,
} from "react-vis";
import { gridXValues, gridYValues, initialAudiometryPoints } from "../js/utils";

export default function MiniLineChart({
  color,
  bkgColor,
  airPoints,
  bonePoints,
  thresholdPoints,
}) {
  const [airData, setAirData] = useState(airPoints);
  const [boneData, setBoneData] = useState(bonePoints);
  const [thresholdData, setThresholdData] = useState(thresholdPoints);

  useEffect(() => {
    setAirData(airPoints);
  }, [airPoints]);

  useEffect(() => {
    setBoneData(bonePoints);
  }, [bonePoints]);

  useEffect(() => {
    setThresholdData(thresholdPoints);
  }, [thresholdPoints]);

  const xValues = gridXValues;
  const yValues = gridYValues;

  return (
    <div className="chart-container" style={{ width: "150px" }}>
      <div
        style={{
          position: "absolute",
          top: 2.5,
          left: 16.5,
          width: "122px",
          height: "115px",
          backgroundColor: bkgColor,
          pointerEvents: "none",
        }}
      ></div>
      <XYPlot
        width={150}
        height={125}
        xType="ordinal"
        yType="linear"
        xDomain={xValues}
        yDomain={[Math.min(...yValues), Math.max(...yValues)]}
        margin={{ left: 10, right: 5, top: 2.5, bottom: 7.5 }}
        style={{ position: "relative" }}
      >
        <HorizontalGridLines style={{ stroke: "#a6dfff" }} />
        <VerticalGridLines style={{ stroke: "#a6dfff" }} />
        <LineSeries
          className="first-series"
          data={airData}
          color={color}
          style={{
            strokeLinejoin: "round",
            strokeWidth: 2,
            fill: "transparent",
          }}
        />
        <LineSeries
          className="second-series"
          data={boneData}
          color={color}
          style={{
            strokeLinejoin: "round",
            strokeWidth: 2,
            fill: "transparent",
          }}
          strokeDasharray="12, 5"
        />
        <LineSeries
          className="third-series"
          data={thresholdData}
          color={color}
          style={{
            strokeLinejoin: "round",
            strokeWidth: 1,
            fill: "transparent",
          }}
          strokeDasharray="4, 4"
        />
        <LineSeries data={initialAudiometryPoints} color={"transparent"} />
      </XYPlot>
    </div>
  );
}
